// Polyfill for Resize Observer
// Used internally by onLayout in RNW
// Still using global polyfill until
// importing the polyfill actually removes the warning
// https://github.com/necolas/react-native-web/issues/934

if (typeof global.ResizeObserver === 'undefined') {
  require('resize-observer-polyfill/dist/ResizeObserver.global');
}
